import { Actions, RoomContractorHistoryEntity } from 'src/types'
import {
  SelectContractorHistoriesResponse,
  SelectContractorHistory,
  ContractorHistoryActorType,
} from 'src/types/generated'

type ToEntitiesInput = {
  response: SelectContractorHistoriesResponse
}

export const ContractorHistoryTranslator = {
  toEntities: (input: ToEntitiesInput): RoomContractorHistoryEntity[] => {
    const { response } = input

    return response.histories.map((contractorHistory: SelectContractorHistory) => {
      return {
        timestamp: new Date(contractorHistory.timestamp),
        actor: contractorHistory.actor
          ? {
              id: contractorHistory.actor.id,
              name: contractorHistory.actor.name ?? null,
              type:
                contractorHistory.actor.type === ContractorHistoryActorType.WorksUser
                  ? 'user'
                  : 'contractor',
              companyRoleNames: contractorHistory.actor.companyRoleNames
                ? contractorHistory.actor.companyRoleNames.map(roleName => roleName)
                : undefined,
            }
          : undefined,
        action: contractorHistory.action as Actions,
      }
    })
  },
}
